import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Sarah Johnson',
  role: 'Aromatherapist',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&auto=format&fit=crop',
  quote: "The purity of Shiriaka's lavender oil is exceptional. My clients report deeper relaxation and better sleep compared to other brands I've used in my practice.",
  rating: 5
}, {
  id: 2,
  name: 'Michael Omondi',
  role: 'Wellness Coach',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=150&auto=format&fit=crop',
  quote: "I recommend Shiriaka's tea tree oil to all my clients dealing with skin issues. The antibacterial properties are potent, and it's gentler than other brands I've tried.",
  rating: 5
}, {
  id: 3,
  name: 'Emily Wangari',
  role: 'Yoga Instructor',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=150&auto=format&fit=crop',
  quote: 'The eucalyptus oil creates the perfect atmosphere for my breathing exercises. My students notice the difference immediately when I use Shiriaka oils in our sessions.',
  rating: 5
}, {
  id: 4,
  name: 'David Kimani',
  role: 'Massage Therapist',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=150&auto=format&fit=crop',
  quote: 'The carrier oils from Shiriaka blend perfectly with essential oils for massage therapy. My clients consistently comment on the quality and the results.',
  rating: 5
}];
const TestimonialsSection = () => {
  return <section className="py-24 bg-[#f8f9f4] relative overflow-hidden" data-id="element-471">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-6xl h-[500px] bg-[#f0f7eb] rounded-[50%] -mt-[350px] transform rotate-180" data-id="element-472"></div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-473">
        <div className="text-center mb-16" data-id="element-474">
          <div className="inline-flex items-center px-4 py-2 bg-[#f0f7eb] text-[#2e7d32] text-sm font-medium rounded-full mb-4" data-id="element-475">
            <span data-id="element-476">Testimonials</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-477">
            What Our Customers Say
          </h2>
          <div className="w-16 h-1 bg-[#2e7d32] mx-auto mt-6" data-id="element-478"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-479">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300" data-id="element-480">
              <div className="flex items-center mb-6" data-id="element-481">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-5 w-5 ${i < testimonial.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-482" />)}
              </div>
              <p className="text-gray-600 italic mb-8 text-base leading-relaxed" data-id="element-483">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center" data-id="element-484">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-[#f0f7eb]" onError={e => {
              e.currentTarget.src = `https://ui-avatars.com/api/?name=${testimonial.name.replace(' ', '+')}&background=e8f5e9&color=2e7d32&size=48`;
            }} data-id="element-485" />
                <div data-id="element-486">
                  <h4 className="font-semibold text-gray-900" data-id="element-487">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-488">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-16 text-center" data-id="element-489">
          <div className="inline-flex items-center bg-white px-8 py-4 rounded-full shadow-lg" data-id="element-490">
            <span className="text-gray-900 font-medium mr-2" data-id="element-491">Trusted by</span>
            <span className="text-[#2e7d32] font-bold text-xl" data-id="element-492">10,000+</span>
            <span className="text-gray-900 font-medium ml-2" data-id="element-493">
              happy customers
            </span>
          </div>
        </div>
      </div>
    </section>;
};
export default TestimonialsSection;